import { render } from "./TraumatologyOrthopedicsPage.vue?vue&type=template&id=8a53b82c"
import script from "./TraumatologyOrthopedicsPage.vue?vue&type=script&lang=js"
export * from "./TraumatologyOrthopedicsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__